// Find all links on the page
let allLinks = document.querySelectorAll("body a");
const vw = Math.max(
	document.documentElement.clientWidth || 0,
	window.innerWidth || 0
);
// Apply only if on mobile'ish view
if (vw <= 980) {
	let mobileNotice = document.querySelector(".mobile-notice");
	// IF link href contains selected string. Disable click and open modal
	allLinks.forEach((link) => {
		if (
			link.href.includes("igland.inonit.no") &&
			link.getAttribute("data-link") !== "allow"
		) {
			link.addEventListener("click", function (e) {
				e.preventDefault();
				let body = document.querySelector("body");
				mobileNotice.classList.add("open");
			});
			// If link is open and modal is showing allow click to go to spesified link
			let validLink = document.querySelector(".mobile-notice a");
			validLink.addEventListener("click", function (e) {
				window.open.href = validLink.href;
			});
			// If link is open and modal is showing allow click to close modal
			let closeMobileNotice = document.querySelector("#close-mobile-notice");
			closeMobileNotice.addEventListener("click", function () {
				mobileNotice.classList.remove("open");
			});
		}
	});
}
